export  function formatTypeMoviment(value) {
  if (value === 'SALE') {
   return 'VENDA'
  }
  else if (value === 'DEVOLUTION') {
   return 'DEVOLUÇÃO'
  }
  else if (value === 'CASHOUT') {
   return 'CASHOUT'
  }
  else  {
   return ''
  }
}

export function formatInstituition(value) {
  if (value === 1) {
   return 'MATERA'
  }
  else if (value === 2) {
   return 'SHIPAY'
  }
  else if (value === 3) {
   return 'BB'
  }
}

export function formatNumber(n) {
  return n.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 })
}

export const textLabels = {
  body: {
    noMatch: "Nenhum registro encontrado",
    toolTip: "Classificar",
  },
  pagination: {
    next: "Próxima página",
    previous: "Página anterior",
    rowsPerPage: "Por página:",
    displayRows: "de",
  },
  toolbar: {
    search: "Busca",
    downloadCsv: "Download CSV",
    print: "Imprimir",
    viewColumns: "Ver Colunas",
    filterTable: "Filtrar Tabelas",
  },
  filter: {
    all: "Todos",
    title: "FILTROS",
    reset: "LIMPAR",
  },
  viewColumns: {
    title: "Ver Colunas",
    titleAria: "Ver/Esconder Colunas da Tabela",
  },
  selectedRows: {
    text: "registros(s) selecionados",
    delete: "Excluir",
    deleteAria: "Excluir registros selecionados",
  },
}